import { parse } from "querystring"

import { isBrowser } from "utils/infrastructure/ssg-utils"

const parsedQuery = (isBrowser() ? parse(location.search.replace("?", "")) : undefined) ?? {}

export function getNextLink() {
    if (!isBrowser()) {
        return
    }
    const searchParams = new URLSearchParams(window.location.search)

    if (searchParams.has("next")) {
        return searchParams.get("next")
    }
}

export function getRedirectLink() {
    return typeof parsedQuery.next === "string" ? parsedQuery.next : undefined
}

export function getPromoCode() {
    return typeof parsedQuery.promo_code === "string" ? parsedQuery.promo_code : undefined
}
